export default __webpack_public_path__ + "static/media/hide.f1871b15.svg";